import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stkts { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @MaxLength(1,{message: '流程碼 (KEY0) 資料太長'})
    KEY0: string = '1';            // 流程碼 1 [DEF:"1"]

    @IsNotEmpty({message: '交易日期 (TS001) 不可空白'}) 
    @MaxLength(8,{message: '交易日期 (TS001) 資料太長'})
    TS001: string = '';            // 交易日期 8 struct STOCKORDER

    @IsNotEmpty({message: '帳號 (TS002) 不可空白'}) 
    @MaxLength(20,{message: '帳號 (TS002) 資料太長'})
    TS002: string = '';            // 帳號 20 bstrFullAccount  分公司代碼＋帳號7碼 F0200008728692

    @IsNotEmpty({message: '序號 (TS003) 不可空白'}) 
    @MaxLength(4,{message: '序號 (TS003) 資料太長'})
    TS003: string = '';            // 序號 4 

    @IsNumber() 
    TS004: number = 0;            // 上市上櫃 4 SHORT	sPrime;		{{ 0:上市上櫃 1:興櫃 }}

    @MaxLength(20,{message: '商品代號 (TS005) 資料太長'})
    TS005: string = '';            // 商品代號 20 bstrStockNo;		//委託股票代號

    @IsNumber() 
    TS006: number = 0;            // 分類 4 SHORT	sPeriod;		{{ 0:盤中 1:盤後 2:盤後零股 4:盤中零股}}

    @IsNumber() 
    TS007: number = 0;            // 種類 4 SHORT	sFlag;		{{ 0:現股 1:融資 2:融券 3:無券 }}

    @IsNumber() 
    TS008: number = 0;            // 買賣 4 SHORT	sBuySell		{{ 0:買進 1:賣出 }}

    @MaxLength(8,{message: '委託價 (TS009) 資料太長'})
    TS009: string = '';            // 委託價 8 BSTR	bstrPrice;			//委託價格，「M」表示參考價（昨收價）

    @IsNumber() 
    TS010: number = 0;            // 張數/股數 8 LONG	nQty;			//整股交易為張數，如果是零股則為股數

    @IsNumber() 
    TS011: number = 0;            // 委託條件 4 [DEF:0] LONG	nTradeType;	 [證券逐筆交易] {{0:ROD 1:IOC 2:FOK}}

    @IsNumber() 
    TS012: number = 2;            // 特別交易類型 4 [DEF:2] SHORT	sSpecialTradeType;		[證券逐筆交易] {{1:市價 2:限價}}  (市價單之委託價格Price請給0; 限價單之委託價格Price 不可為0)

    @IsNumber() 
    TS013: number = 0;            // 交易情況 1 nOrderCond;				{{0:ROD 3:IOC 4:FOK}}

    @IsNumber() 
    TS014: number = 0;            // 觸價方向 1 nTriggerDir;				{{1:大於等於 2:小於等於}}

    @IsNumber() 
    TS015: number = 0;            // 預風控功能 1 nPreRiskFlag;	{{0:關閉預風控 1:開啟預風控}} (不支援信用交易)

    @IsNumber() 
    TS016: number = 0;            // 是否為長效單 1 nLongActionFlag;			{{0:否 1:是}}

    @MaxLength(8,{message: '長效單結束日期 (TS016A) 資料太長'})
    TS016A: string = '';            // 長效單結束日期 8 bstrLongEndDate			//(YYYYMMDD共8碼, EX: 20220630)

    @IsNumber() 
    TS016B: number = 0;            // 觸發結束條件 1 nLAType	{{1:效期內觸發即失效 3:效期內完全成交即失效}}

    @MaxLength(3,{message: '單別 (TS017) 資料太長'})
    TS017: string = '';            // 單別 3 {{0:一般 MIT:MIT單 MST:MST單  AB:AB單}}

    @MaxLength(10,{message: '登入代號 (TS018) 資料太長'})
    TS018: string = '';            // 登入代號 10 

    @MaxLength(255,{message: '備註 (TS019) 資料太長'})
    TS019: string = '';            // 備註 255 

    @MaxLength(1,{message: '暫存 (TS020) 資料太長'})
    TS020: string = 'N';            // 暫存 1 [DEF:"N"] bAsyncOrder 非同步委託 是否為非同步委託。

    @MaxLength(255,{message: '失敗原因 (TS021) 資料太長'})
    TS021: string = '';            // 失敗原因 255 

    @MaxLength(1,{message: '價差委託 (TS022) 資料太長'})
    TS022: string = 'N';            // 價差委託 1 [DEF:"N"]

    @MaxLength(1,{message: '更新api (TS023) 資料太長'})
    TS023: string = 'N';            // 更新api 1 [DEF:"N"]

    @MaxLength(10,{message: '委託書號 (TS024) 資料太長'})
    TS024: string = '';            // 委託書號 10 BSTR	bstrBookNo;				//委託書號{改價使用}

    @MaxLength(13,{message: '委託序號 (TS025) 資料太長'})
    TS025: string = '';            // 委託序號 13 BSTR	bstrSeqNo;				//委託序號{改價使用}

    @IsNumber() 
    TS026: number = 0;            // 成交口數 8 //交易口數。

    @MaxLength(8,{message: '異動時間 (TS027) 資料太長'})
    TS027: string = '';            // 異動時間 8 hh:mm:ss

    @MaxLength(1,{message: '狀態 (TS028) 資料太長'})
    TS028: string = '1';            // 狀態 1 [DEF:"1"] {{1.已暫存 2.委託失敗 3:已刪除 5.委託成功   8:部分成交  9:全部成交}}

    @MaxLength(60,{message: '商品名稱 (TS029) 資料太長'})
    TS029: string = '';            // 商品名稱 60 

    @MaxLength(1,{message: '商品分類 (TS030) 資料太長'})
    TS030: string = '0';            // 商品分類 1 [DEF:"0"] MA019 JCKMD STKMA.MA019 {{0:上市 1:上櫃 2:期貨 3:選擇權 4:興櫃 5:盤中零股-上市 6:盤中零股-上櫃  O:海期 Z:指數}}

    @IsNumber() 
    TS031: number = 0;            // 平均成交價 11.3 


}
